import React from 'react';
import { Container, MainContent } from './layout-style';
import Header from '../../shared/components/header/header';
import { Footer } from '../../shared/components/footer/footer';

export const Layout = ({ children }) => {
  return (
    <Container>
      <Header />
       <MainContent >{children}</MainContent>
      <Footer />
    </Container>
  );
};
